// import 'babel-polyfill';
// import React from 'react';
// import './index.less';

// const noticeTemp = global.ruleTemp || '';
// const RuleTemp = () => (
//   <div className="useContainer" dangerouslySetInnerHTML={{ __html: noticeTemp }} />
// );
// export default RuleTemp;


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';

import wrapReact from '../../util/react';

import { sessionStore } from '../../util/storage';

export class Rule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelectedConuntry: '',
    };
  }


  ChooseCountry=(e, data) => {
    // alert(data);
    const { isSelectedConuntry } = this.state;
    this.setState({
      isSelectedConuntry: data === '#8' ? '' : !isSelectedConuntry,
    },
    () => {
      sessionStore.set('isSelectedConuntry', data === '#8' ? '' : data);
    });
  }

  render() {
    document.title = 'Privacy notice';
    // const { intl } = this.props;
    // const { formatMessage } = intl;
    const { isSelectedConuntry } = this.state;
    let htmlContent = '';
    let selectLocationText = 'Zurück, um Ihren Standort auszuwählen';
    const country = sessionStore.get('isSelectedConuntry');
    // alert(country);
    switch (country) {
      case '#1':
        htmlContent = window?.rule_aut;
        break;
      case '#2':
        htmlContent = window?.rule_de_new;
        break;
      case '#3':
        htmlContent = window?.ruleTempLuxEn;
        selectLocationText = 'Back to select your location';
        break;
      case '#4':
        htmlContent = window?.ruleTempLuxFr;
        selectLocationText = 'Retour pour selectionner votre pays';
        break;
      case '#5':
        htmlContent = window?.ruleTempLuxGe;
        break;
      case '#8':
        break;
      default:
        htmlContent = window?.ruleTemp;
        break;
    }

    return (


      <div className="useContainer">
        {!isSelectedConuntry && (
        <p className="countryMenu">
          <h3>Select your location | Wählen Sie Ihren Standort</h3>
          <a href="#1" onClick={(e => this.ChooseCountry(e, '#1'))}>Austria</a>
          <br />
          <a href="#2" onClick={(e => this.ChooseCountry(e, '#2'))}>Germany</a>
          <br />
          {/* <a href="#3" onClick={(e => this.ChooseCountry(e, '#3'))}>Luxembourg (English)</a>
          <br />
          <a href="#4" onClick={(e => this.ChooseCountry(e, '#4'))}>Luxembourg (French)</a>
          <br />
          <a href="#5" onClick={(e => this.ChooseCountry(e, '#5'))}>Luxembourg (German)</a>
          <br /> */}
        </p>
        )}

        {isSelectedConuntry && (
        <p>
          <a className="ac" href="#8" onClick={(e => this.ChooseCountry(e, '#8'))}>
            {/* {formatMessage({
              id: 'Header.notice.BackChooseCountry',
              defaultMessage:
              'Back to select your location',
            })} */}
            {selectLocationText}
          </a>
          <br />
        </p>
        )}
        {isSelectedConuntry && (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        )}
      </div>
    );
  }
}

Rule.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default wrapReact(Rule, 'component_Rule');
